import { useEffect, useState } from 'react';

/** Returns a Date that updates every second. */
export function useClock() {
  const [time, setTime] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return time;
}

export function formatUtcStamp(d: Date): string {
  return d.toISOString().replace('T', ' / ').slice(0, 19) + ' UTC';
}

export function formatCityTime(d: Date, tz: string): string {
  try {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).format(d);
  } catch {
    return '--:--:--';
  }
}
